import { render, staticRenderFns } from "./bankTransactions.vue?vue&type=template&id=8b87868c&scoped=true&"
import script from "./bankTransactions.vue?vue&type=script&lang=js&"
export * from "./bankTransactions.vue?vue&type=script&lang=js&"
import style0 from "./bankTransactions.vue?vue&type=style&index=0&id=8b87868c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b87868c",
  null
  
)

export default component.exports